import anchor from './anchor';

let $catFilter = $('.is-filter-post-categories');

export default {
  load() {
    if ($catFilter.length) {
      if($catFilter.val() !== '0') {
        anchor.go_to($('#filter_post_categories'));
      }

      $catFilter.change(function() {
        $catFilter.closest('form').submit();
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/util/actus.js